import React from 'react';
import { Box, Typography, IconButton, Paper, Avatar } from '@mui/material';
import MessageIcon from '@mui/icons-material/Message';

const UserCard = ({ user, sx = {} }) => {
  // Generate initials from first and last name
  const getInitials = (firstName, lastName) => {
    return `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase();
  };

  // Generate a consistent color based on the user's name
  const stringToColor = (string) => {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xFF;
      color += ('00' + value.toString(16)).substr(-2);
    }
    return color;
  };

  const avatarColor = stringToColor(`${user.firstName} ${user.lastName}`);

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        backgroundColor: 'background.paper',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        width: '100%',
        ...sx
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
        <Avatar
          src={user.profilePicture}
          sx={{
            width: 40,
            height: 40,
            mr: 2,
            bgcolor: avatarColor,
            fontSize: '1rem',
            fontWeight: 500
          }}
        >
          {getInitials(user.firstName, user.lastName)}
        </Avatar>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, flex: 1, minWidth: 0 }}>
          <Typography 
            variant="subtitle1" 
            sx={{ 
              fontWeight: 600,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            {`${user.firstName} ${user.lastName}`}
          </Typography>
          <Typography 
            variant="body2" 
            color="text.secondary"
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            {user.email}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default UserCard; 